import React, { useEffect, useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface CorporateTrainingFormProps {
  onSuccess?: (reference: string) => void;
}
export const CorporateTrainingForm: React.FC<CorporateTrainingFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    numberOfParticipants: 5,
    trainingTopics: [] as string[],
    preferredDate: '',
    additionalNotes: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [totalAmount, setTotalAmount] = useState(250000);
  const trainingOptions = ['Networking & Relationship Building', 'Collaboration & Team Dynamics', 'Artificial Intelligence & Digital Tools', 'Digital Transformation Strategy', 'Leadership Development', 'Personal Branding & Professional Presence', 'Strategic Communication', 'Innovation & Creative Problem Solving'];
  useEffect(() => {
    const pricePerPerson = 50000;
    const calculatedAmount = formData.numberOfParticipants * pricePerPerson;
    setTotalAmount(calculatedAmount);
  }, [formData.numberOfParticipants]);
  const handleChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (name === 'trainingTopics') {
      setFormData(prev => ({
        ...prev,
        trainingTopics: checked ? [...prev.trainingTopics, value] : prev.trainingTopics.filter(topic => topic !== value)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'number' ? parseInt(value) : value
      }));
    }
    setTimeout(() => {
      const requiredFields = ['companyName', 'contactPerson', 'email', 'phone', 'numberOfParticipants', 'preferredDate'];
      const isComplete = requiredFields.every(field => formData[field]) && formData.email.includes('@') && formData.trainingTopics.length > 0;
      setIsFormComplete(isComplete);
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-859" data-mp="2uizh4y3ygrbq">
      <div className="mb-6" data-id="element-860" data-mp="1q2cq045fdno">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-861" data-mp="1palt2lhy43q">
          Corporate Training Request
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-862" data-mp="3sv2dw7iu3qt6">
          Transform your team with our expert-led training programs. ₦50,000 per
          participant per day.
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-863" data-mp="6i3ug1k35wl3">
        <div data-id="element-864" data-mp="3exdsmykuuhnl">
          <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-865" data-mp="3ex43fd7mweiy">
            Company Name <span className="text-gray-500" data-id="element-866" data-mp="39z2i0lmqk34b">(required)</span>
          </label>
          <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter company name" required data-id="element-867" data-mp="3ny235jb1hzvq" />
        </div>
        <div data-id="element-868" data-mp="136tcpszmkr7l">
          <label htmlFor="contactPerson" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-869" data-mp="136jni7memo2y">
            Contact Person <span className="text-gray-500" data-id="element-870" data-mp="y8i3nkh5mkqf">(required)</span>
          </label>
          <input type="text" id="contactPerson" name="contactPerson" value={formData.contactPerson} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter contact person name" required data-id="element-871" data-mp="16oz6n0tzwvvy" />
        </div>
        <div data-id="element-872" data-mp="wtxdzv0ihbom">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-873" data-mp="11qfhkrk3v3zd">
            Email <span className="text-gray-500" data-id="element-874" data-mp="1pgi9n7o0s9xz">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter email address" required data-id="element-875" data-mp="1pima1fmpmqti" />
        </div>
        <div data-id="element-876" data-mp="1kp9ya634qei6">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-877" data-mp="1kp04e7eyrn77">
            Phone Number <span className="text-gray-500" data-id="element-878" data-mp="28euhmq373drz">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter phone number" required data-id="element-879" data-mp="2d5kne4fj9in7" />
        </div>
        <div data-id="element-880" data-mp="khwpdgzd0f57">
          <label htmlFor="numberOfParticipants" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-881" data-mp="khd7u1dmfsrp">
            Number of Participants{' '}
            <span className="text-gray-500" data-id="element-882" data-mp="flftg0lx4whk">(required, minimum 5)</span>
          </label>
          <input type="number" id="numberOfParticipants" name="numberOfParticipants" value={formData.numberOfParticipants} onChange={handleChange} min="5" className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-883" data-mp="am37rj6s9vgk" />
          <p className="text-sm text-gray-600 mt-1" data-id="element-884" data-mp="yi7iyrs207u2">
            Total: ₦{totalAmount.toLocaleString()}
          </p>
        </div>
        <div data-id="element-885" data-mp="tjw6saeadl8o">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-886" data-mp="tibdeo3pk8ce">
            Training Topics{' '}
            <span className="text-gray-500" data-id="element-887" data-mp="1r031udiy6qvw">(select at least one)</span>
          </label>
          <div className="space-y-2" data-id="element-888" data-mp="1m705jxmsd3c0">
            {trainingOptions.map(option => <div key={option} className="flex items-center" data-id="element-889" data-mp="1tjg6g5axmu4c">
                <input type="checkbox" id={`topic-${option}`} name="trainingTopics" value={option} checked={formData.trainingTopics.includes(option)} onChange={handleChange} className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-890" data-mp="1tl14w60dax7h" />
                <label htmlFor={`topic-${option}`} className="text-gray-700" data-id="element-891" data-mp="28fxjd0yrsgt0">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-892" data-mp="2cfy75c7re4cq">
          <label htmlFor="preferredDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-893" data-mp="2hgvmzi5aqmb2">
            Preferred Training Date{' '}
            <span className="text-gray-500" data-id="element-894" data-mp="2m8n83d5onztt">(required)</span>
          </label>
          <input type="date" id="preferredDate" name="preferredDate" value={formData.preferredDate} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-895" data-mp="2r7893esrenjb" />
        </div>
        <div data-id="element-896" data-mp="306liy8kspe4k">
          <label htmlFor="additionalNotes" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-897" data-mp="3086cbuvdir0u">
            Additional Notes <span className="text-gray-500" data-id="element-898" data-mp="112v4e2c2ylqk">(optional)</span>
          </label>
          <textarea id="additionalNotes" name="additionalNotes" value={formData.additionalNotes} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Any specific requirements or questions?" data-id="element-899" data-mp="w4lbxzhqpz8n" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={totalAmount} email={formData.email} name={formData.contactPerson} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData,
      service: 'Corporate Training'
    }} data-id="element-900" data-mp="1jsbhdp4yc6nv" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-901" data-mp="1sshs5399msjc">
          Complete all required fields to proceed
        </button>}
    </div>;
};